import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {
  getModifierColor,
  ModifierColor
} from '../../../constants/modifier-colors.constant';

@Component({
  selector: 'pos-modifier-color-tag',
  templateUrl: './modifier-color-tag.component.html',
  styleUrls: ['./modifier-color-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModifierColorTagComponent implements OnInit, OnChanges {
  @Input() value: string | null = null;
  @Input() showCheckmark = false;
  @Input() editMode = false;

  colorConfig: ModifierColor | undefined;

  ngOnInit() {
    this.colorConfig = getModifierColor(this.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.colorConfig = getModifierColor(this.value);
    }
  }
}
